import { deviceType } from 'detect-it';

export function isTouchDevice() {
    return deviceType === 'touchOnly';
}
